import { environment } from 'src/environments/environment';
import { EnvironmentService } from './environment.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { LegalDocument } from '../models/legal-document';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LegalDocumentTypes } from '../models/legal-document-types';


@Injectable({
	providedIn: 'root'
})
export class LegalDocumentsService {

	constructor(
		private envService: EnvironmentService,
		private http: HttpClient) { }

	getLatestDocumentByType(type: string): Observable<LegalDocument> {
		return this.http
			.get<LegalDocument>(this.envService.userHost + '/v1/legaldocuments/' + type)
			.pipe(catchError(error => {
				if (!environment.production)
					console.error('LegalDocumentsService::Error::GET', error);
				return throwError(error);
			}))
	}
}
